module.exports = __webpack_public_path__ + "img/honghe.5ac0babf.png";